module.exports = __webpack_public_path__ + "img/cero-cinco.53d58428.png";